import React, { useCallback, useEffect, useState, } from "react";



import apiService from "../services/apiService";



import I from "../component/Icon";



import SB from "../component/SearchBox";



import ConfirmDlg from "../component/ConfirmDialog";



import BookMasterForm from "../component/BookMasterForm.jsx";



import BookMasterView from "../component/BookMasterView.jsx";



const PAGE_SIZE = 10;



const showNotification = (type, message) => {



    if (



        typeof document === "undefined" ||



        typeof window === "undefined"



    ) {



        return;



    }



    const existingNotification =



        document.getElementById(



            "book-master-page-notification"



        );



    if (existingNotification) {



        existingNotification.remove();



    }



    const notification =



        document.createElement("div");



    notification.id =



        "book-master-page-notification";



    notification.textContent =



        `${type === "success" ? "✓" : "✕"} ${message}`;



    Object.assign(



        notification.style,



        {



            position: "fixed",



            top: "20px",



            right: "20px",



            zIndex: "99999",



            minWidth: "280px",



            maxWidth: "420px",



            padding: "12px 16px",



            borderRadius: "8px",



            backgroundColor:



                type === "success"



                    ? "#d1e7dd"



                    : "#f8d7da",



            color:



                type === "success"



                    ? "#0f5132"



                    : "#842029",



            border:



                type === "success"



                    ? "1px solid #badbcc"



                    : "1px solid #f5c2c7",



            fontSize: "14px",



            fontWeight: "600",



            boxShadow:



                "0 4px 12px rgba(0,0,0,0.15)",



        }



    );



    document.body.appendChild(



        notification



    );



    window.setTimeout(() => {



        if (notification.parentNode) {



            notification.remove();



        }



    }, 3000);



};



// JSON from Dapper/stored procedures may be nested or serialized as a string.

const decodeJson = (value) => {

    if (typeof value !== "string") return value;

    try { return JSON.parse(value); } catch { return value; }

};



const getOutput = (data) => {

    const root = decodeJson(data);

    // Preserve rowCount from pagination output; do not unwrap its result array.

    return decodeJson(root?.output ?? root?.Output ?? root);

};



const unwrapBookById = (data) => {

    let record = decodeJson(data);

    for (let i = 0; i < 8; i += 1) {

        if (Array.isArray(record)) return record[0] ?? null;

        if (!record || typeof record !== "object") return null;

        const next = record.output ?? record.Output ?? record.result ?? record.Result ??

            record.data ?? record.Data ?? record.book ?? record.Book ??

            record.bookMaster ?? record.BookMaster;

        if (next == null) return record;

        record = decodeJson(next);

    }

    return record;

};



const getBookList = (output) => {

    const decoded = decodeJson(output);

    if (Array.isArray(decoded)) return decoded;

    if (!decoded || typeof decoded !== "object") return [];

    for (const key of ["items", "Items", "records", "Records", "bookMasters", "BookMasters",

        "books", "Books", "rows", "Rows", "data", "Data", "result", "Result"]) {

        const value = decodeJson(decoded[key]);

        if (Array.isArray(value)) return value;

    }

    return [];

};



const getDetailList = (record) => {

    const raw = record?.teaBooAssDetlst ?? record?.TeaBooAssDetlst ??

        record?.bokDetlst ?? record?.BokDetlst ?? record?.BokDetLst ??

        record?.bookMasterDetails ?? record?.BookMasterDetails ??

        record?.details ?? record?.Details ?? [];

    const parsed = decodeJson(raw);

    if (Array.isArray(parsed)) return parsed;

    return parsed && typeof parsed === "object" ? [parsed] : [];

};



const normalizeBook = (book) => {

    const details = getDetailList(book);

    const first = details[0] || {};

    return {

        ...book,

        id: book?.id ?? book?.Id ?? book?.bookMasterId ?? book?.BookMasterId ??

            book?.bookId ?? book?.BookId ?? 0,

        bookCode: book?.bookCode ?? book?.BookCode ?? "",

        competitiveExams: book?.competitiveExams ?? book?.CompetitiveExams ?? "",

        bookName: book?.bookName ?? book?.BookName ?? first?.bookName ?? first?.BookName ?? "",

        amount: Number(book?.amount ?? book?.Amount ?? first?.amount ?? first?.Amount ?? 0),

        totalAmount: Number(book?.totalAmount ?? book?.TotalAmount ?? 0),

        qty: Number(book?.qty ?? book?.Qty ?? 0),

        description: book?.description ?? book?.Description ?? book?.remark ?? book?.Remark ?? "",

        isActive: book?.isActive ?? book?.IsActive ?? true,

        bokDetlst: details,

    };

};



const loadBookWithDetails = async (master) => {

    if (!master.id) return master;

    try {

        const response = await apiService.get(`BookMaster/getBookMasterById/${master.id}`);

        if (response?.data?.isSuccess === false || response?.data?.IsSuccess === false) return master;

        const detailRecord = unwrapBookById(response?.data);

        if (!detailRecord || typeof detailRecord !== "object" || Array.isArray(detailRecord)) return master;

        // The by-ID API provides teaBooAssDetlst, unlike the paginated master list.

        return normalizeBook({ ...master, ...detailRecord });

    } catch (error) {

        console.warn("Unable to load book name for book", master.id, error);

        return master;

    }

};



export default function BookMasterPage() {



    const [



        books,



        setBooks,



    ] = useState([]);



    const [sub, setSub] =



        useState("list");



    const [sel, setSel] =



        useState(null);



    const [edit, setEdit] =



        useState(null);



    const [del, setDel] =



        useState(null);



    const [q, setQ] =



        useState("");



    const [



        pageNumber,



        setPageNumber,



    ] = useState(1);



    const [



        totalRecords,



        setTotalRecords,



    ] = useState(0);



    const [



        totalPages,



        setTotalPages,



    ] = useState(1);



    const pageNumbers = Array.from(



        { length: totalPages },



        (_, index) => index + 1



    );



    const [



        loading,



        setLoading,



    ] = useState(false);



    const [



        deleting,



        setDeleting,



    ] = useState(false);



    const loadBooks = useCallback(



        async (



            searchValue = "",



            currentPage = 1



        ) => {



            try {



                setLoading(true);



                const payload = {



                    Page: Number(currentPage) || 1,



                    PageSize: PAGE_SIZE,



                    SearchTerm: String(



                        searchValue || ""



                    ).trim(),



                    SortDirection: "DESC",



                    SortField: "Id",



                    IsActive: true,



                    IncludeInActive: false,



                };



                console.log(



                    "Get Paginated Book Request:",



                    payload



                );



                const response =



                    await apiService.post(



                        "BookMaster/getPaginatedBookMasters",



                        payload



                    );



                const data =



                    response?.data;



                console.log(



                    "Get Paginated Book Response:",



                    data



                );



                if (



                    data?.isSuccess ===



                    false ||



                    data?.IsSuccess ===



                    false



                ) {



                    throw new Error(



                        data?.failureReason ??



                        data?.FailureReason ??



                        data?.message ??



                        data?.Message ??



                        "Failed to load books"



                    );



                }



                const output =



                    getOutput(data);



                const list =



                    getBookList(



                        output



                    );



                const normalizedBooks =



                    list



                        .map(normalizeBook)



                        .filter((book) => {



                            return (



                                book.isActive === true ||



                                book.isActive === 1 ||



                                book.isActive === "1" ||



                                String(



                                    book.isActive



                                ).toLowerCase() ===



                                "true"



                            );



                        });

                const enrichedBooks = await Promise.all(normalizedBooks.map(loadBookWithDetails));

                setBooks(enrichedBooks);

                const recordsCount =



                    Number(



                        output?.rowCount ??



                        output?.RowCount ??



                        output?.totalRecords ??



                        output?.TotalRecords ??



                        output?.totalCount ??



                        output?.TotalCount ??



                        output?.recordCount ??



                        output?.RecordCount ??



                        data?.rowCount ??



                        data?.RowCount ??



                        data?.totalRecords ??



                        data?.TotalRecords ??



                        data?.totalCount ??



                        data?.TotalCount ??



                        normalizedBooks.length



                    ) || 0;



                setTotalRecords(recordsCount);



                const calculatedPages =



                    Math.max(



                        1,



                        Math.ceil(



                            recordsCount / PAGE_SIZE



                        )



                    );



                setTotalPages(calculatedPages);



                if (



                    recordsCount > 0 &&



                    currentPage > calculatedPages



                ) {



                    setPageNumber(



                        calculatedPages



                    );



                }



                if (



                    currentPage >



                    calculatedPages &&



                    calculatedPages >



                    0



                ) {



                    setPageNumber(



                        calculatedPages



                    );



                }



            } catch (error) {



                console.error(



                    "Book Master List API Error:",



                    error



                );



                setBooks([]);



                setTotalRecords(0);



                setTotalPages(1);



                const message =



                    error?.response?.data



                        ?.failureReason ??



                    error?.response?.data



                        ?.FailureReason ??



                    error?.response?.data



                        ?.message ??



                    error?.response?.data



                        ?.Message ??



                    error?.message ??



                    "Unable to load books";



                showNotification(



                    "error",



                    message



                );



            } finally {



                setLoading(false);



            }



        },



        []



    );



    useEffect(() => {



        const timer =



            setTimeout(() => {



                loadBooks(



                    q,



                    pageNumber



                );



            }, 300);



        return () => {



            clearTimeout(timer);



        };



    }, [



        q,



        pageNumber,



        loadBooks,



    ]);



    const handleSearchChange = (



        value



    ) => {



        setQ(value);



        setPageNumber(1);



    };



    const doAdd =



        async () => {



            if (



                pageNumber !== 1



            ) {



                setPageNumber(1);



            } else {



                await loadBooks(



                    q,



                    1



                );



            }



            showNotification(



                "success",



                "Book added successfully!"



            );



            setSub("list");



        };



    const doUpdate =



        async () => {



            setEdit(null);



            await loadBooks(



                q,



                pageNumber



            );



            showNotification(



                "success",



                "Book updated successfully!"



            );



            setSub("list");



        };



    const doDelete =



        async () => {



            if (



                !del ||



                deleting



            ) {



                return;



            }



            const bookId =



                Number(



                    del?.id ??



                    del?.Id ??



                    del?.bookId ??



                    del?.BookId ??



                    0



                );



            if (!bookId) {



                showNotification(



                    "error",



                    "Invalid book id."



                );



                setDel(null);



                return;



            }



            try {



                setDeleting(true);



                console.log(



                    "Delete Book ID:",



                    bookId



                );



                const response =



                    await apiService.delete(



                        `BookMaster/DeleteBookMaster/${bookId}`



                    );



                const data =



                    response?.data;



                console.log(



                    "Delete Book Response:",



                    data



                );



                if (



                    data?.isSuccess ===



                    false ||



                    data?.IsSuccess ===



                    false



                ) {



                    throw new Error(



                        data?.failureReason ??



                        data?.FailureReason ??



                        data?.message ??



                        data?.Message ??



                        "Book delete failed"



                    );



                }



                showNotification(



                    "success",



                    data?.message ||



                        data?.Message ||



                        "Book deleted successfully!"



                );



                setDel(null);



                if (



                    books.length === 1 &&



                    pageNumber > 1



                ) {



                    setPageNumber(



                        (previous) =>



                            previous - 1



                    );



                } else {



                    await loadBooks(



                        q,



                        pageNumber



                    );



                }



            } catch (error) {



                console.error(



                    "Delete Book API Error:",



                    error



                );



                const message =



                    error?.response?.data



                        ?.failureReason ??



                    error?.response?.data



                        ?.FailureReason ??



                    error?.response?.data



                        ?.message ??



                    error?.response?.data



                        ?.Message ??



                    error?.message ??



                    "Book delete failed";



                showNotification(



                    "error",



                    message



                );



            } finally {



                setDeleting(false);



            }



        };



    if (



        sub === "add"



    ) {



        return (



            <BookMasterForm



                onSave={doAdd}



                onBack={() =>



                    setSub(



                        "list"



                    )



                }



            />



        );



    }



    if (



        sub === "view" &&



        sel



    ) {



        return (



            <BookMasterView



                book={sel}



                onBack={() => {



                    setSel(null);



                    setSub(



                        "list"



                    );



                }}



                onEdit={(fullBook) => {



                    setEdit(fullBook || sel);



                    setSel(null);



                    setSub(



                        "edit"



                    );



                }}



            />



        );



    }



    if (



        sub === "edit" &&



        edit



    ) {



        return (



            <BookMasterForm



                book={edit}



                onSave={



                    doUpdate



                }



                onBack={() => {



                    setEdit(null);



                    setSub(



                        "list"



                    );



                }}



            />



        );



    }



    const totalQty =



        books.reduce(



            (



                sum,



                book



            ) =>



                sum +



                (Number(



                    book?.qty



                ) || 0),



            0



        );



    const totalValue =



        books.reduce(



            (



                sum,



                book



            ) =>



                sum +



                (Number(



                    book?.amount



                ) || 0) *



                (Number(



                    book?.qty



                ) || 0),



            0



        );



    return (



        <>



                        <style>{`
              .book-master-pagination {
                box-sizing: border-box !important;
                display: flex !important;
                flex-direction: row !important;
                flex-wrap: nowrap !important;
                align-items: center !important;
                justify-content: space-between !important;
                width: 100% !important;
                max-width: 100% !important;
                min-width: 0 !important;
                overflow: hidden !important;
                gap: 8px !important;
              }
              .book-master-count {
                flex: 0 0 auto !important;
                white-space: nowrap !important;
              }
              .book-master-controls {
                display: flex !important;
                align-items: center !important;
                flex: 1 1 0 !important;
                width: auto !important;
                min-width: 0 !important;
                max-width: 100% !important;
                overflow: hidden !important;
                gap: 5px !important;
                flex-wrap: nowrap !important;
                justify-content: flex-end !important;
              }
              .book-master-controls > button {
                flex: 0 0 auto !important;
                white-space: nowrap !important;
              }
              .book-master-pages {
                display: flex !important;
                align-items: center !important;
                flex: 0 1 auto !important;
                min-width: 0 !important;
                max-width: 100% !important;
                overflow-x: auto !important;
                overflow-y: hidden !important;
                flex-wrap: nowrap !important;
                white-space: nowrap !important;
                -webkit-overflow-scrolling: touch;
                scrollbar-width: thin;
                overscroll-behavior-x: contain;
                gap: 4px !important;
              }
              .book-master-pages > button { flex: 0 0 auto !important; }
              @media (max-width: 600px) {
                .book-master-pagination { gap: 5px !important; padding-left: 0 !important; padding-right: 0 !important; }
                .book-master-count { font-size: 9px !important; }
                .book-master-controls { gap: 3px !important; }
                .book-master-controls > button {
                  min-width: 42px !important;
                  padding: 0 4px !important;
                  font-size: 9px !important;
                }
                .book-master-pages { flex: 1 1 0 !important; }
                .book-master-pages > button { min-width: 28px !important; padding: 0 5px !important; }
              }
            `}</style>

            {/* PAGE HEADER */}



            <div className="ph">



                <div className="ph-title">



                    Book Master



                </div>



                <div className="ph-sub">



                    Manage all books



                </div>



            </div>



            {/* SUMMARY */}



            <div



                className="mr"



                style={{



                    display: "flex",



                    gap: "12px",



                }}



            >



                {[



                    [



                        totalRecords,



                        "Total Books",



                        "#EFF6FF",



                        "#2563EB",



                    ],



                    [



                        totalQty,



                        "Book Quantity",



                        "#ECFDF5",



                        "#10B981",



                    ],



                    [



                        totalValue,



                        "Book Value",



                        "#FFF7ED",



                        "#EA580C",



                    ],



                ].map(



                    ([



                        value,



                        label,



                        bg,



                        color,



                    ]) => (



                        <div



                            key={label}



                            className="mc"



                            style={{



                                background:



                                    bg,



                                width:



                                    "180px",



                                minWidth:



                                    "180px",



                                maxWidth:



                                    "180px",



                                flex:



                                    "0 0 180px",



                            }}



                        >



                            <div



                                className="mv"



                                style={{



                                    color,



                                }}



                            >



                                {label ===



                                    "Book Value"



                                    ? `₹${Number(



                                        value



                                    ).toLocaleString(



                                        "en-IN"



                                    )}`



                                    : value}



                            </div>



                            <div className="ml">



                                {label}



                            </div>



                        </div>



                    )



                )}



            </div>



            <div



                className="tb"



                style={{



                    display:



                        "flex",



                    alignItems:



                        "center",



                    gap: 10,



                    flexWrap:



                        "wrap",



                }}



            >



                <SB



                    value={q}



                    onChange={



                        handleSearchChange



                    }



                    placeholder="Search book..."



                />



                <button



                    type="button"



                    className="btn bp"



                    onClick={() =>



                        setSub(



                            "add"



                        )



                    }



                >



                    <I



                        n="plus"



                        s={14}



                        c="#fff"



                    />



                    Add Book



                </button>



            </div>



            <div



                style={{



                    marginBottom:



                        14,



                    fontSize:



                        12,



                    color:



                        "var(--t3)",



                }}



            >



                {q.trim() ? (



                    <>



                        Search results for:{" "}



                        <strong



                            style={{



                                color:



                                    "var(--t1)",



                            }}



                        >



                            "{q}"



                        </strong>



                        {" • "}



                        {totalRecords}{" "}



                        record



                        {totalRecords !==



                            1



                            ? "s"



                            : ""}



                    </>



                ) : (



                    <>







                    </>



                )}



            </div>



            <div className="card">



                <div className="tw">



                    <table>



                        <thead>



                            <tr>



                                <th>



                                    Book Code



                                </th>



                                <th>



                                    Book/QuestionSet Name



                                </th>

                                <th>Competitive Exams</th>



                                <th>



                                    Amount



                                </th>



                                <th>



                                    Quantity



                                </th>



                                <th>



                                    Description



                                </th>



                                <th>



                                    Actions



                                </th>



                            </tr>



                        </thead>



                        <tbody>



                            {loading ? (



                                <tr>



                                    <td



                                        colSpan={7}



                                        style={{



                                            textAlign:



                                                "center",



                                            padding:



                                                32,



                                            color:



                                                "var(--t3)",



                                        }}



                                    >



                                        Loading books...



                                    </td>



                                </tr>



                            ) : books.length ===



                                0 ? (



                                <tr>



                                    <td



                                        colSpan={7}



                                        style={{



                                            textAlign:



                                                "center",



                                            padding:



                                                "32px",



                                            color:



                                                "var(--t3)",



                                        }}



                                    >



                                        📚{" "}



                                        {q.trim()



                                            ? "No books found for your search"



                                            : "No books found"}



                                    </td>



                                </tr>



                            ) : (



                                books.map(



                                    (



                                        book,



                                        index



                                    ) => (



                                        <tr



                                            key={



                                                book.id ??



                                                index



                                            }



                                            style={{



                                                cursor:



                                                    "pointer",



                                            }}



                                            onClick={() => {



                                                setSel(



                                                    book



                                                );



                                                setSub(



                                                    "view"



                                                );



                                            }}



                                        >



                                            <td>



                                                <span



                                                    className="tdb"



                                                    style={{



                                                        color:



                                                            "var(--p)",



                                                    }}



                                                >



                                                    {book.bookCode ||



                                                        "-"}



                                                </span>



                                            </td>



                                            <td className="td2">



                                                {book.bookName ||



                                                    "-"}



                                            </td>

                                            <td className="td2">{book.competitiveExams || "-"}</td>



                                            <td



                                                style={{



                                                    fontWeight:



                                                        600,



                                                }}



                                            >



                                                ₹



                                                {Number(



                                                    book.amount ||



                                                    0



                                                ).toLocaleString(



                                                    "en-IN"



                                                )}



                                            </td>



                                            <td



                                                style={{



                                                    fontWeight:



                                                        600,



                                                }}



                                            >



                                                {book.qty ??



                                                    0}



                                            </td>



                                            <td className="td2">



                                                {book.description ||



                                                    "-"}



                                            </td>



                                            <td



                                                onClick={(



                                                    event



                                                ) =>



                                                    event.stopPropagation()



                                                }



                                            >



                                                <div



                                                    className="ra"



                                                    style={{



                                                        display:



                                                            "flex",



                                                        alignItems:



                                                            "center",



                                                        gap: 6,



                                                        opacity:



                                                            1,



                                                        visibility:



                                                            "visible",



                                                    }}



                                                >



                                                    {/* VIEW */}



                                                    <button



                                                        type="button"



                                                        className="btn btn-g btn-sm"



                                                        title="View Book"



                                                        onClick={(



                                                            event



                                                        ) => {



                                                            event.stopPropagation();



                                                            setSel(



                                                                book



                                                            );



                                                            setSub(



                                                                "view"



                                                            );



                                                        }}



                                                    >



                                                        <I



                                                            n="eye"



                                                            s={11}



                                                        />



                                                    </button>



                                                    {/* EDIT */}



                                                    <button



                                                        type="button"



                                                        className="btn btn-g btn-sm"



                                                        title="Edit Book"



                                                        onClick={(



                                                            event



                                                        ) => {



                                                            event.stopPropagation();



                                                            setEdit(



                                                                book



                                                            );



                                                            setSub(



                                                                "edit"



                                                            );



                                                        }}



                                                    >



                                                        <I



                                                            n="edit"



                                                            s={11}



                                                        />



                                                    </button>



                                                    {/* DELETE */}



                                                    <button



                                                        type="button"



                                                        className="btn btn-d btn-sm"



                                                        title="Delete Book"



                                                        onClick={(



                                                            event



                                                        ) => {



                                                            event.stopPropagation();



                                                            setDel(



                                                                book



                                                            );



                                                        }}



                                                    >



                                                        <I



                                                            n="trash"



                                                            s={11}



                                                        />



                                                    </button>



                                                </div>



                                            </td>



                                        </tr>



                                    )



                                )



                            )}



                        </tbody>



                    </table>



                </div>



            </div>



            {!loading &&



                totalRecords > 0 && (



                    <div className="book-master-pagination"



                        style={{



                            width: "100%",



                            display: "flex",



                            alignItems: "center",



                            justifyContent: "space-between",



                            gap: "16px",



                            marginTop: "16px",



                            padding: "12px 4px 4px",



                            borderTop:



                                "1px solid #eef2f7",



                        }}



                    >



                        {/* SHOWING RECORDS */}



                        <div className="book-master-count"



                            style={{



                                display: "flex",



                                alignItems: "center",



                                whiteSpace: "nowrap",



                                fontSize: "11px",



                                lineHeight: "16px",



                                color: "var(--t3)",



                            }}



                        >



                            Showing{" "}



                            <span



                                style={{



                                    margin: "0 4px",



                                    fontWeight: 600,



                                    color: "var(--t2)",



                                }}



                            >



                                {(pageNumber - 1) *



                                    PAGE_SIZE +



                                    1}



                            </span>



                            –



                            <span



                                style={{



                                    margin: "0 4px",



                                    fontWeight: 600,



                                    color: "var(--t2)",



                                }}



                            >



                                {Math.min(



                                    pageNumber *



                                    PAGE_SIZE,



                                    totalRecords



                                )}



                            </span>



                            {" "}of{" "}



                            <span



                                style={{



                                    marginLeft: "4px",



                                    fontWeight: 600,



                                    color: "var(--t2)",



                                }}



                            >



                                {totalRecords}



                            </span>



                        </div>



                        {/* PAGINATION BUTTONS */}



                        <div className="book-master-controls"



                            style={{



                                display: "flex",



                                alignItems: "center",



                                gap: "5px",



                            }}



                        >



                            {/* BACK */}



                            <button



                                type="button"



                                disabled={



                                    pageNumber === 1 ||



                                    loading



                                }



                                onClick={() =>



                                    setPageNumber(



                                        (previous) =>



                                            Math.max(



                                                1,



                                                previous - 1



                                            )



                                    )



                                }



                                style={{



                                    height: "32px",



                                    minWidth: "66px",



                                    padding: "0 10px",



                                    display:



                                        "inline-flex",



                                    alignItems:



                                        "center",



                                    justifyContent:



                                        "center",



                                    gap: "3px",



                                    border:



                                        "1px solid #e2e8f0",



                                    borderRadius:



                                        "6px",



                                    background:



                                        pageNumber === 1



                                            ? "#f8fafc"



                                            : "#fff",



                                    color:



                                        pageNumber === 1



                                            ? "#cbd5e1"



                                            : "#475569",



                                    fontSize: "11px",



                                    fontWeight: 500,



                                    cursor:



                                        pageNumber === 1



                                            ? "not-allowed"



                                            : "pointer",



                                    transition:



                                        "all 0.15s ease",



                                }}



                            >



                                <span



                                    style={{



                                        fontSize: "16px",



                                        lineHeight: 1,



                                    }}



                                >



                                    ‹



                                </span>



                                Back



                            </button>



                            {/* PAGE NUMBERS */}



                            <div className="book-master-pages"



                                style={{



                                    display: "flex",



                                    alignItems: "center",



                                    gap: "4px",



                                }}



                            >



                                {pageNumbers.map(



                                    (page) => (



                                        <button



                                            key={page}



                                            type="button"



                                            disabled={



                                                loading



                                            }



                                            onClick={() =>



                                                setPageNumber(



                                                    page



                                                )



                                            }



                                            style={{



                                                height:



                                                    "32px",



                                                minWidth:



                                                    "32px",



                                                padding:



                                                    "0 9px",



                                                display:



                                                    "inline-flex",



                                                alignItems:



                                                    "center",



                                                justifyContent:



                                                    "center",



                                                border:



                                                    pageNumber ===



                                                        page



                                                        ? "1px solid #2563eb"



                                                        : "1px solid #e2e8f0",



                                                borderRadius:



                                                    "6px",



                                                background:



                                                    pageNumber ===



                                                        page



                                                        ? "#2563eb"



                                                        : "#fff",



                                                color:



                                                    pageNumber ===



                                                        page



                                                        ? "#fff"



                                                        : "#475569",



                                                fontSize:



                                                    "11px",



                                                fontWeight:



                                                    600,



                                                cursor:



                                                    loading



                                                        ? "not-allowed"



                                                        : "pointer",



                                                transition:



                                                    "all 0.15s ease",



                                            }}



                                        >



                                            {page}



                                        </button>



                                    )



                                )}



                            </div>



                            {/* NEXT */}



                            <button



                                type="button"



                                disabled={



                                    pageNumber >=



                                    totalPages ||



                                    loading



                                }



                                onClick={() =>



                                    setPageNumber(



                                        (previous) =>



                                            Math.min(



                                                totalPages,



                                                previous +



                                                1



                                            )



                                    )



                                }



                                style={{



                                    height: "32px",



                                    minWidth: "66px",



                                    padding: "0 10px",



                                    display:



                                        "inline-flex",



                                    alignItems:



                                        "center",



                                    justifyContent:



                                        "center",



                                    gap: "3px",



                                    border:



                                        "1px solid #e2e8f0",



                                    borderRadius:



                                        "6px",



                                    background:



                                        pageNumber >=



                                            totalPages



                                            ? "#f8fafc"



                                            : "#fff",



                                    color:



                                        pageNumber >=



                                            totalPages



                                            ? "#cbd5e1"



                                            : "#475569",



                                    fontSize: "11px",



                                    fontWeight: 500,



                                    cursor:



                                        pageNumber >=



                                            totalPages



                                            ? "not-allowed"



                                            : "pointer",



                                    transition:



                                        "all 0.15s ease",



                                }}



                            >



                                Next



                                <span



                                    style={{



                                        fontSize:



                                            "16px",



                                        lineHeight: 1,



                                    }}



                                >



                                    ›



                                </span>



                            </button>



                        </div>



                    </div>



                )}



            {del && (



                <ConfirmDlg



                    title="Delete Book"



                    msg={`Delete "${del.bookName ||



                        "this book"



                        }"? This cannot be undone.`}



                    onOk={doDelete}



                    onCancel={() =>



                        !deleting &&



                        setDel(null)



                    }



                />



            )}



        </>



    );



}